import { styled } from '@mui/material/styles';
import MuiTableCell from '@mui/material/TableCell';

const StyledTableHeaderCell = styled(MuiTableCell, {
    shouldForwardProp: prop => !['isDragging', 'rtl'].includes(prop),
}) `
  ${({ theme, isDragging, rtl }) => `
      border: 0;
      transition: background-color ${theme.transitions.duration.fast} linear, color ${theme.transitions.duration.fast} linear, border ${theme.transitions.duration.fast} linear;
      border: none;
      display: inline-block;
      overflow: hidden;
      font-family: ${theme.typography.subtitle2.fontFamily};
      font-size: ${theme.typography.subtitle2.fontSize};
      font-weight: ${theme.typography.subtitle2.fontWeight};
      letter-spacing: ${theme.typography.subtitle2.letterSpacing};
      text-transform: ${theme.typography.subtitle2.textTransform};
      color: ${theme.palette.N30.main};
      margin: ${theme.spacing(0)};
      padding: ${rtl ? theme.spacing(0, 0.25, 0, 0) : theme.spacing(0, 0, 0, 0.25)};
            height: 100%;
      opacity: ${!isDragging ? 1 : 0.1};
      headerCellPadding?: number | string;

  `}
`;

export { StyledTableHeaderCell as default };
//# sourceMappingURL=StyledTableHeaderCell.js.map
